import { CalendarView } from "@ds-developer/calendar";
import { calendarActions, store } from "@hubcapp/state";

export const handleViewSelected = (view: CalendarView) =>
  store.dispatch(
    calendarActions.calendarViewSelected({
      view,
    }),
  );

export const handleTodayClicked = () => {
  store.dispatch(
    calendarActions.calendarViewSelected({
      view: CalendarView.day,
    }),
  );
  store.dispatch(
    calendarActions.calendarInitialDateChanged({
      initialDate: new Date(Date.now()),
    }),
  );
};

export const handleAddLessonClicked = () => {
  store.dispatch(
    calendarActions.calendarShowAddLessonModal({
      showAddLessonModal: true,
    }),
  );
};
